
/**
 * Utilitaires pour gérer les tendances de frappe
 */

/**
 * Récupère l'affichage de tendance pour un point et un index donnés
 */
export const getTendencyDisplay = (
  point: string,
  index: number,
  scores: Record<string, (number | null)[]>,
  selectedTest: string | null,
  isIronTest: boolean,
  isDriverTest: boolean,
): string => {
  const score = scores[point]?.[index];
  
  if (score === null || score === undefined) return '-';
  
  // Pour les tests de fer ou driver, obtenir la tendance
  if ((isIronTest || (selectedTest && selectedTest.includes('iron')) || 
      isDriverTest || (selectedTest && selectedTest.includes('driver'))) && selectedTest) {
    const tendencyKey = `${point}_${index}_tendency`;
    const tendencyData = localStorage.getItem(`golf_${selectedTest}_tendencies`);
    
    if (tendencyData) {
      const tendencies = JSON.parse(tendencyData);
      const tendency = tendencies?.[tendencyKey];
      
      if (tendency === 'left') return `${score} ←`;
      if (tendency === 'center') return `${score} ↓`;
      if (tendency === 'right') return `${score} →`;
    }
  }
  
  return String(score);
};
